import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogContent, Typography } from '@material-ui/core'
import { confirmTerm, getTermList } from '@/apis/apiCollection'
import { Checkbox } from 'antd'
import { useTranslation } from "../../langs/useTranslation";

const TermDialog = () => {
  const [open, setOpen] = useState(false)
  const [ind, setInd] = useState(0)
  const [terms, setTerms] = useState([])
  const [checked, setChecked] = useState({})
  const { t } = useTranslation()
  const handleCurTermConfirm = async () => {
    await confirmTerm({
      id: terms[ind].id,
      acceptCheckItemIds: Object.keys(checked).filter(v => checked[v])
    })
    if (ind === terms.length-1) {
      setOpen(false)
      setInd(0)
      setTerms([])
      setChecked({})
    } else {
      setInd(ind+1)
      setChecked({})
    }
  }

  useEffect(() => {
    const lastLoginTime = localStorage.getItem('lastLoginTime')
    if (lastLoginTime && ((Date.now() - parseInt(lastLoginTime)) < 15000)) {
      getTermList().then(({terms}) => {
        if (terms.length) {
          setTerms(terms)
          setInd(0)
          setOpen(true)
        }
      }) 
    }
  }, [])
  if (!open) return null
  const term = terms[ind]
  return (
    <Dialog
      open
      maxWidth={500}
      title="asdf"
      style={{zIndex: 99999}}
    >
      <Typography variant="h5">
        {term.name}
      </Typography>
      <DialogContent
        style={{
          minWidth: 500,
          maxWidth: 700,
          backgroundColor: "#F8F9FC",
          borderRadius: 10,
          marginTop: 18,
          padding: 24
        }}
      >
        <Typography variant="body2">
          {term.content}
        </Typography>
      </DialogContent>
      <div style={{display: 'flex', marginTop: 16, flexWrap: 'wrap'}}>
        { [...term.checkItems].reverse().map(item => {
          return (
            <div style={{width: "50%", wordBreak: "break-all", marginTop: 16}}>
              <Checkbox 
                onChange={(e) => setChecked(v => ({...v, [item.id]: e.target.checked}))}
                key={item.id}
              >
                {item.name}
                {item.required && (
                  <span style={{ color: "red", fontSize: 16, marginLeft: 4 }}>*</span>
                )}
              </Checkbox>
            </div>
          )
        })}
      </div>
      <div style={{marginTop: 16, display: "flex", justifyContent: "center"}}>
        <Button 
          color="primary"
          variant="contained"
          style={{minWidth: 150, maxWidth: 300}}
          disabled={!(term.checkItems
            .filter(v => v.required)
            .map(v => checked[v.id])
            .every(v => v))
          }
          onClick={handleCurTermConfirm}
        >
          {t({defaultMessage: "确认"})}
        </Button>
      </div>
    </Dialog>
  )
}

export default TermDialog